export const workspaceRoute = (slug: string) => `/${slug}`;
export const workspacesRoute = () => `/workspaces`;
export const createWorkspaceRoute = () => "/workspaces/create";
export const connectDWRoute = (slug: string) =>
  `/workspaces/${slug}/connect-dw`;
export const connectExternalTool = (slug: string) =>
  `/${slug}/settings/external-tools`;
